import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import './context-menu.scss';
import Dropdown, { DropdownTypes, DropdownSeparatorId, DropdownTriggers } from '../dropdown';
import CMEmptyState from './views/cm-empty-state/cm-empty-state';

const ContextMenu = ({
  open, items, header, onSelect, onClose, children, closeOnClick, closeOnSelfClick, footerActions,
  triggerEventToOpen,
}) => {
  const processedItems = useMemo(() => items.map((item) => ({
    ...item,
    type: item.type || DropdownTypes.MENU,
  })), [items]);

  const handleItemClicked = useCallback((id) => {
    if (onSelect && typeof onSelect === 'function') {
      onSelect.call(null, id);
    }
  }, [onSelect]);

  return (
    <div className="context-menu-cont">
      <Dropdown
        header={header}
        onClose={onClose}
        defaultOpen={open}
        items={processedItems}
        closeOnClick={closeOnClick}
        trigger={triggerEventToOpen}
        footerActions={footerActions}
        onItemClick={handleItemClicked}
        closeOnSelfClick={closeOnSelfClick}
      >
        {children || <CMEmptyState />}
      </Dropdown>
    </div>
  );
};

ContextMenu.defaultProps = {
  items: [],
  header: '',
  open: false,
  children: null,
  onClose: () => {},
  footerActions: [],
  onSelect: () => {},
  closeOnClick: true,
  closeOnSelfClick: true,
  triggerEventToOpen: DropdownTriggers.CLICK,
};

ContextMenu.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  children: PropTypes.element,
  closeOnClick: PropTypes.bool,
  closeOnSelfClick: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  footerActions: PropTypes.arrayOf(PropTypes.shape({})),
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  triggerEventToOpen: PropTypes.oneOf(Object.values(DropdownTriggers)),
};

export {
  ContextMenu as default,
  DropdownSeparatorId,
};
